import { MobileSpacing } from './MobileResponsiveSpacing';

/**
 * MobileSettingsStyles - Common styles for mobile settings pages
 * Centralized styling to improve DRY principles and consistency
 */

export const MOBILE_SETTINGS_STYLES = {
  // Header styles
  headerLabel: {
    color: 'text.secondary',
    fontSize: MobileSpacing.fontSizeMedium,
    fontWeight: 500,
    textAlign: 'center' as const,
    minWidth: MobileSpacing.minWidth,
  },

  // List item styles
  listItem: {
    '&:hover': {
      bgcolor: 'action.hover',
    },
    '&:active': {
      bgcolor: 'action.selected',
    },
    WebkitTapHighlightColor: 'transparent',
  },
  listItemIcon: {
    minWidth: MobileSpacing.iconSizeSmall,
    color: 'text.secondary',
    '& .MuiSvgIcon-root': {
      fontSize: MobileSpacing.iconSize,
    },
  },
  listItemText: {
    fontSize: MobileSpacing.fontSizeLarge,
    fontWeight: 500,
    color: 'text.primary',
  },
  listContainer: {
    py: 0,
    '& .MuiListItemButton-root': {
      px: MobileSpacing.gapXLarge,
      py: MobileSpacing.gapMedium,
      minHeight: MobileSpacing.minHeight,
    },
  },
  menuBox: {
    bgcolor: 'grey.50',
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
  },

  // Typography styles
  passwordRequirement: {
    fontFamily: '"SF Pro", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '20px',
  },

  // Accordion styles
  accordionTitle: {
    fontSize: '16px',
    fontWeight: 500,
    color: '#000000',
  },
  accordionContent: {
    fontSize: '14px',
    lineHeight: '20px',
    color: '#666666',
    whiteSpace: 'pre-line',
  },
  accordionContainer: {
    backgroundColor: 'white',
    boxShadow: 'none',
    '&:before': { display: 'none' },
    '&.Mui-expanded': { margin: 0 },
  },

  // Link styles
  linkText: {
    color: '#007EFF',
    fontWeight: 400,
  },
  externalLinkIcon: {
    width: '17px',
    height: '17px',
  },
  sectionContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: 0.5,
    mt: 2,
  },
  notificationToggleSpacing: {
    gap: { xs: '32px', sm: '48px', md: '64px' },
    minWidth: { xs: '120px', sm: '140px', md: '160px' },
  },
  externalLink: {
    display: 'flex',
    alignItems: 'center',
    gap: 0.5,
    mt: 2,
  },
  externalLinkText: {
    color: '#007EFF',
    fontWeight: 400,
  },
  descriptionText: {
    fontSize: '16px',
    lineHeight: '20px',
    color: '#666666',
    whiteSpace: 'pre-line',
    textAlign: 'justify',
    mb: MobileSpacing.gapMedium,
  },
} as const;

export type MobileSettingsStylesKey = keyof typeof MOBILE_SETTINGS_STYLES;
